import Pages from '@pages';
import { store } from '../../store/store';
import { pushRoute } from '../../store/thunks/route.thunk';

function goToChannelList() {
  store.dispatch(
    pushRoute({
      route: { Page: Pages.CHANNEL_LIST },
      params: { push: true },
    })
  );
}

export default goToChannelList;
